// src/pages/ApiDocPage.tsx
import { useEffect } from 'react';

function ApiCrmDocPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.redoc.ly/redoc/latest/bundles/redoc.standalone.js';
    script.onload = () => {
      // @ts-ignore
      window.Redoc.init('/api/owly-crm.json', {
        theme: {
          colors: {
            primary: {
              main: '#FF0000',
            },
          },
        },
      }, document.getElementById('redoc-container'));
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <h1>Documentación de APIs</h1>
      <div id="redoc-container" />
    </div>
  );
}

export default ApiCrmDocPage;
